import set from "@rill/set";
import rill from "rill";

import getChat from "./chat.controller.js";

const Chat = (app) => {
  app.at(
    "/chat/*",
    rill()
      .use(set("heading", ["Coaching", "Chat"]))
      .setup((app) => {
        app.get("/", getChat);
        app.post("/", async ({ req, locals, res, api, flash }) => {
          await api(`user/${locals.activeUser._id}`, {
            method: "POST",
            body: req.body,
          });
          flash("success", "Successfully updated");
          res.backDontScroll();
        });
      })
  );
};

export default Chat;
